/**
 * 设备检测工具函数
 */

/**
 * 检测是否为移动设备
 * @returns {boolean}
 */
export function isMobile() {
  if (typeof window === 'undefined' || !window.navigator) {
    return false
  }
  
  const userAgent = navigator.userAgent
  const mobileRegex = /(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  return mobileRegex.test(userAgent)
}

/**
 * 检测是否为平板设备
 * @returns {boolean}
 */
export function isTablet() {
  if (typeof window === 'undefined' || !window.navigator) {
    return false
  }
  
  const userAgent = navigator.userAgent
  const tabletRegex = /(iPad|Android(?!.*Mobile)|Tablet)/i
  return tabletRegex.test(userAgent)
}

/**
 * 检测设备类型
 * @returns {string} 'mobile' | 'tablet' | 'desktop'
 */
export function getDeviceType() {
  if (isMobile()) {
    return 'mobile'
  } else if (isTablet()) {
    return 'tablet'
  }
  return 'desktop'
}

/**
 * 检测浏览器类型
 * @returns {string} 'chrome' | 'firefox' | 'safari' | 'edge' | 'other'
 */
export function getBrowserType() {
  if (typeof window === 'undefined' || !window.navigator) {
    return 'other'
  }
  
  const userAgent = navigator.userAgent
  if (userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Edg') === -1) {
    return 'chrome'
  } else if (userAgent.indexOf('Firefox') > -1) {
    return 'firefox'
  } else if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1) {
    return 'safari'
  } else if (userAgent.indexOf('Edg') > -1) {
    return 'edge'
  }
  return 'other'
}

